import React from 'react';
import { useParams } from 'react-router-dom';
import { PageContainer } from '../../toolympus/components/Pages';
import { FormWrapper } from '../../toolympus/components/primitives/Forms';

export const ManualPage = () => {
    const { slug } = useParams<{ slug: string }>();
    return <FormWrapper><PageContainer apiPath="/api/page-manual" slug={slug} /></FormWrapper>;
}
